//npm install exceljs
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import { useHistory } from 'react-router-dom';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import { fetchData, deleteData, activateData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import ScnhinderPrint from './CompanyBillReport';
import Brotherprint from './brotherBillreport';
import ReactDOM from 'react-dom';
import PrintIcon from '@mui/icons-material/Print';
import { Tooltip } from '@mui/material';
import AddCommentIcon from '@mui/icons-material/AddComment';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import { Tabs, Tab, Box, Typography, CircularProgress } from '@mui/material';


function CompanyPrint() {
    const [data, setData] = useState([]);
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const history = useHistory();

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        // Token is not expired, fetch data
        fetchtableData();
    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchtableData();
    }, []);
    const [id, setId] = useState([]);

    const fetchtableData = async () => {

        fetchData('BrotherPrintApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setData(response.response_data);
                    setId(response.response_data.id);

                }
            })
            .catch((error) => {
                console.error('Error fetching Customer Details:', error);
            });

    };

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const handlePrint = async (printid) => {
        try {

            const response = await fetchData('BrotherPrintApi', `/SalePrint/${printid}`, token);
            const labelData = response.response_data;
            const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            // Render the component only if customerCompany is 'Brother'
            ReactDOM.render(
                <Brotherprint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();
            // iframe.contentWindow.print();
            setTimeout(() => {
                iframe.contentWindow.print();
            }, 1000);

        } catch (error) {
            console.error('Error printing Invoice:', error);
        }
    };

    // for filling the Feild Report Section 


    const [isLoading, setIsLoading] = useState(false);
    const [ServiceType, setServiceType] = useState("");
    const [Calltype, setCalltype] = useState("");
    const [ModalDescription, setModalDescription] = useState("");
    const [UnitSerialNo, setUnitSerialNo] = useState("");
    const [InstallationDate, setInstallationDate] = useState("");
    const [Distance, setDistance] = useState("");
    const [EngineerDiagnosis, setEngineerDiagnosis] = useState("");
    const [Observation, setObservation] = useState("");
    const [Action, setAction] = useState("");
    const [PendingReason, setPendingReason] = useState("");
    const [RemarksforASP, setRemarksforASP] = useState("");

    const [warranty, setwarranty] = useState("");
    const [ProductGroup, setProductGroup] = useState("");
    const [ProductCategory, setProductCategory] = useState("");
    const [feildData, setFeildData] = useState([]);


    const [isModalOpen, setIsModalOpen] = useState(false);
    const DATAID = id;
    const openModal = () => {
        handleHistoryClick(DATAID);
        setIsModalOpen(true);
    };

    const handleHistoryClick = async (DATAID) => {
        try {
            const response = await fetchData('RequestdetailsApi', `/RequestDetails/${DATAID}`, token);
            if (response.responseCode === '1111') {
                setFeildData(response.response_data);
                setIsModalOpen(true);
                // console.log('Modal state set to true:', showModal);
            } else {
                console.error('Invalid response code:', response.responseCode);
            }
        } catch (error) {
            console.error('Error fetching Order Items:', error);
        }
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const submitData = (event) => {
        event.preventDefault();
        setIsLoading(true);

        const payload = {
            CompanyId: companyId,
            CustomerId: feildData.customerID,
            VisitId: feildData.requestID,
            ServiceType: ServiceType,
            Calltype: Calltype,
            ModalDescription: ModalDescription,
            UnitSerialNo: UnitSerialNo,
            InstallationDate: InstallationDate,
            Distance: Distance,
            EngineerDiagniosis: EngineerDiagnosis,
            Observation: Observation,
            Action: Action,
            PendingReason: PendingReason,
            RemarksforASP: RemarksforASP,
            ProductCategory: ProductCategory,
            ProductGroup: ProductGroup,
            warranty: warranty
        };

        postData('BrotherPrintApi', payload, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    window.location.reload();
                }
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error submitting data:', error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const [tabIndex, setTabIndex] = useState(0);

    const handleTabChange = (event, newIndex) => {
        setTabIndex(newIndex);
    };

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto">
            <div className='w-full mb-2 flex'>
                <h6 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', fontWeight: 'bold', textTransform: 'uppercase' }}>Call Report Create</h6>
                <Tooltip title="Search Sale Item Here">
                    <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                        <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                        {showSearchInput && (
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={handleSearch}
                                style={{ marginLeft: '10px', width: '200px' }}
                            />
                        )}
                    </div>
                </Tooltip>
            </div>
            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#090040' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Company</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Name</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Contact</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: '#D5F5E3' }}>
                            {filteredData.map(item => (
                                <TableRow key={item.Id} >
                                    <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '14px', padding: '3px', textAlign: 'center', width: '150px' }}>{item.invoicedate && new Date(item.invoicedate).toLocaleDateString('en-GB')}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'center' }}>{item.customerCompany}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'center' }}>{item.customer}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'center' }}>{item.customerContact}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '14px', padding: '3px', borderRight: '1px solid #ccc', textAlign: 'center', width: '150px' }}>

                                        {item.isbrotherprintComplete !== true ? (
                                            !isModalOpen ? (
                                                <IconButton onClick={() => handleHistoryClick(item.id)}>
                                                    <SaveAsIcon style={{ color: 'darkmagenta' }} />
                                                </IconButton>
                                            ) : null
                                        ) : (
                                            <Tooltip title="Call Summary Print">
                                                <IconButton onClick={() => handlePrint(item.brotherID)}>
                                                    <PrintIcon style={{ color: 'coral' }} />
                                                </IconButton>
                                            </Tooltip>
                                        )}

                                        {/* {item.isbrotherprintComplete !== true ? (
                                            !isModalOpen ? (
                                                <IconButton onClick={() => handleHistoryClick(item.id)}>
                                                    <SaveAsIcon style={{ color: 'darkmagenta' }} />
                                                </IconButton>
                                            ) : null
                                        ) : (
                                            <Tooltip title="Status">
                                               
                                               <span style={{color:'darkgreen'}}>Completed</span> 
                                            </Tooltip>

                                        )} */}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>


            </div >
            <Modal open={isModalOpen} className={isModalOpen ? 'notification-modal' : ''}>
                <div className="notification-modal" style={{ backgroundColor: 'white', maxHeight: '700px' }}>

                    <div className="w-full mb-4 flex justify-end">
                        <Tooltip title="Add">
                            <Button onClick={submitData} style={{ color: 'green', cursor: 'pointer' }}>
                                ADD <CheckCircleIcon />
                            </Button>
                        </Tooltip>

                        <Tooltip title="Cancel">
                            <Button onClick={closeModal} style={{ color: 'red', border: 'none', background: 'none', cursor: 'pointer' }}>
                                Cancel<CancelIcon />
                            </Button>
                        </Tooltip>
                    </div>

                    <h4 style={{ textAlign: 'center', fontFamily: 'Times New Roman', fontWeight: 'bolder', color: 'darkred' }}>Feild Report</h4>
                    <br></br>

                    <Tabs value={tabIndex} onChange={handleTabChange}>
                        <Tab label="Service Details" />
                        <Tab label="Engineer Report" />
                    </Tabs>
                    <div className="bg-tabcolor-100 rounded-lg shadow-lg p-6">

                        <div className="w-full mb-4 flex">
                            <label className="block tracking-wide text-black text-base font-bold mb-2">
                                Customer: <strong style={{ color: 'blueviolet' }}>{feildData.customer}</strong>
                            </label>
                        </div>
                        <TabPanel value={tabIndex} index={0}>
                            <div className="w-full mb-4 flex">
                                <div className="w-1/7 mr-3" style={{ width: '275px', marginTop: '-20px' }}>

                                    <label className="input-label" htmlFor="ServiceType">
                                        Service Type
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={ServiceType}
                                        onChange={(e) => setServiceType(e.target.value)}
                                        placeholder="ServiceType"

                                    />
                                </div>

                                <div className="w-1/7 mr-3" style={{ width: '275px', marginTop: '-20px' }}>
                                    <label className="input-label" htmlFor="Calltype">
                                        Call type
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={Calltype}
                                        onChange={(e) => setCalltype(e.target.value)}
                                        placeholder="Calltype"

                                    />
                                </div>
                            </div>
                            <div className="w-full mb-4 flex">

                                <div className="w-1/7 mr-3" style={{ width: '275px', marginTop: '-20px' }}>
                                    <label className="input-label" htmlFor="UnitSerialNo">
                                        UnitSerialNo
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={UnitSerialNo}
                                        onChange={(e) => setUnitSerialNo(e.target.value)}
                                        placeholder="UnitSerialNo"
                                    />
                                </div>
                                <div className="w-1/7 mr-3" style={{ width: '275px', marginTop: '-20px' }}>

                                    <label className="input-label" htmlFor="InstallationDate">
                                        InstallationDate
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={InstallationDate}
                                        onChange={(e) => setInstallationDate(e.target.value)}
                                        type="date"
                                        placeholder="InstallationDate"
                                    />
                                </div>

                            </div>
                            <div className="w-full mb-4 flex">

                                <div className="w-1/7 mr-3" style={{ width: '275px', marginTop: '-20px' }}>

                                    <label className="input-label" htmlFor="Distance">
                                        Distance
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={Distance}
                                        onChange={(e) => setDistance(e.target.value)}
                                        placeholder="Distance"
                                    />
                                </div>

                                <div className="w-1/7 mr-3" style={{ width: '275px', marginTop: '-20px' }}>

                                    <label className="input-label" htmlFor="Warranty">
                                        Warranty
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={warranty}
                                        onChange={(e) => setwarranty(e.target.value)}
                                        placeholder="warranty"
                                    />
                                </div>

                            </div>
                            <div className="w-full mb-4 flex">

                                <div className="w-1/7 mr-3" style={{ width: '275px', marginTop: '-20px' }}>

                                    <label className="input-label" htmlFor="ProductGroup">
                                        ProductGroup
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={ProductGroup}
                                        onChange={(e) => setProductGroup(e.target.value)}
                                        placeholder="ProductGroup"
                                    />
                                </div>
                                <div className="w-1/7 mr-3" style={{ width: '275px', marginTop: '-20px' }}>

                                    <label className="input-label" htmlFor="ProductCategory">
                                        ProductCategory
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={ProductCategory}
                                        onChange={(e) => setProductCategory(e.target.value)}
                                        placeholder="ProductCategory"
                                    />
                                </div>
                            </div>
                            <div className="w-1/7 mr-3" style={{ width: '275px', marginTop: '-20px' }}>

                                <label className="input-label" htmlFor="ModalDescription">
                                    ModalDescription
                                </label>
                                <textarea
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={ModalDescription}
                                    onChange={(e) => setModalDescription(e.target.value)}
                                    placeholder="Modal Description"
                                    rows={3}
                                    maxLength={250}
                                />
                            </div>
                        </TabPanel>

                        <TabPanel value={tabIndex} index={1}>
                            <div className="w-full mb-4 flex">

                                <div className="w-1/7 mr-3" style={{ width: '400px', marginTop: '-22px' }}>
                                    <label className="input-label" htmlFor="RemarksforASP">
                                        Engineer Diagnosis
                                    </label>
                                    <textarea
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={EngineerDiagnosis}
                                        onChange={(e) => setEngineerDiagnosis(e.target.value)}
                                        placeholder="Engineer Diagnosis"
                                        rows={3}
                                        maxLength={250}
                                    />
                                </div>

                                <div className="w-1/7 mr-3" style={{ width: '400px', marginTop: '-22px' }}>
                                    <label className="input-label" htmlFor="RemarksforASP">
                                        Observation
                                    </label>
                                    <textarea
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={Observation}
                                        onChange={(e) => setObservation(e.target.value)}
                                        placeholder="Observation"
                                        rows={3}
                                        maxLength={250}
                                    />
                                </div>

                            </div>

                            <div className="w-full mb-4 flex">

                                <div className="w-1/7 mr-3" style={{ width: '400px', marginTop: '-22px' }}>
                                    <label className="input-label" htmlFor="RemarksforASP">
                                        Action
                                    </label>
                                    <textarea
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={Action}
                                        onChange={(e) => setAction(e.target.value)}
                                        placeholder="Action"
                                        rows={3}
                                        maxLength={250}
                                    />
                                </div>


                                <div className="w-1/7 mr-3" style={{ width: '400px', marginTop: '-22px' }}>
                                    <label className="input-label" htmlFor="RemarksforASP">
                                        PendingReason
                                    </label>
                                    <textarea
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={PendingReason}
                                        onChange={(e) => setPendingReason(e.target.value)}
                                        placeholder="Pending Reason"
                                        rows={3}
                                        maxLength={250}
                                    />
                                </div>

                            </div>


                            <div className="w-full mb-4 flex">
                                <div className="w-1/7 mr-3" style={{ width: '400px', marginTop: '-22px' }}>
                                    <label className="input-label" htmlFor="RemarksforASP">
                                        Remarks for ASP
                                    </label>
                                    <textarea
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={RemarksforASP}
                                        onChange={(e) => setRemarksforASP(e.target.value)}
                                        placeholder="RemarksforASP"
                                        rows={3}
                                        maxLength={250}
                                    />
                                </div>
                            </div>
                        </TabPanel>
                    </div>
                </div>

            </Modal >
        </div >
    );
}

export default CompanyPrint;

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
};
